var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderNav',{attrs:{"auth":false}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container"},[_vm._v(" Поддержка ")])])
}]

export { render, staticRenderFns }